import { Getters } from '@/types/store/getters';
import { SearchDataProp, SearchFieldValue } from '@/types/searchType';

export const getters: Getters = {
    getSearchFieldCaption: (state, getters) => (key, property) => {
        const value = getters.getInputData[property] as SearchFieldValue;
        if (!value) {
            return null;
        }
        if (Array.isArray(value)) {
            const names = value.filter(option => !!option.value).map(option => option.caption);
            return names.length ? names.join(', ') : null;
        }
        if (typeof value === 'object') {
            return value.value ? value.caption : null;
        }
        return value.toString();
    },
    getSearchRangeField: (state, getters) => (key, property, suffix = null) => {
        const from = getters.getSearchFieldCaption(key, property + '_from' as SearchDataProp);
        const to = getters.getSearchFieldCaption(key, property + '_to' as SearchDataProp);
        return from || to
            ? { from: from, to: to, suffix: suffix }
            : null;
    },
    selectedFilters: (state, getters) => {
        const selected = [];
        const key = getters.activeSearch.key;
        const data = getters.getInputData;

        if (Object.keys(data).length === 0) {
            return selected;
        }

        ['make', 'model', 'model_variant_id', 'car_class'].forEach(field => {
            selected.push(getters.getSearchFieldCaption(key, field as SearchDataProp));
        });

        selected.push(data.keywords || null);
        selected.push(getters.getSearchFieldCaption(key, 'fuel_type'));
        selected.push(getters.getSearchFieldCaption(key, 'trans_type'));
        selected.push(getters.getSearchRangeField(key, 'age'));
        selected.push(getters.getSearchRangeField(key, 'price'));
        selected.push(getters.getSearchRangeField(key, 'ivendi_payment', 'per month'));
        selected.push(getters.getSearchFieldCaption(key, 'ivendi_deposit'));
        selected.push(getters.getSearchFieldCaption(key, 'ivendi_term'));

        const sellers = getters.getSearchFieldCaption(key, 'user_type');
        if (sellers) {
            selected.push(sellers + ' Seller');
        }

        ['mileage_to', 'body_style', 'eng_size', 'doors', 'colour', 'location'].forEach(field => {
            selected.push(getters.getSearchFieldCaption(key, field as SearchDataProp));
        });

        const distance = getters.getSearchFieldCaption(key, 'distance_miles');
        if (data.distance_enabled && data.distance_postcode && distance) {
            selected.push(`Within ${distance} miles of ${data.distance_postcode}`);
        }

        const selectedPeriod = state.periods.find(p => p.value === state.notificationData.period);
        if (selectedPeriod && selectedPeriod.interval) {
            const endDate = new Date();
            endDate.setDate(endDate.getDate() + 7 * selectedPeriod.interval);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
            const monthName = months[endDate.getMonth()];
            const dateOfMonth = endDate.getDate();
            let dateSuffix = '';
            if ([1, 21, 31].includes(dateOfMonth)) {
                dateSuffix = 'st';
            } else if ([2, 22].includes(dateOfMonth)) {
                dateSuffix = 'nd';
            } else if ([3, 23].includes(dateOfMonth)) {
                dateSuffix = 'rd';
            } else {
                dateSuffix = 'th';
            }
            selected.push(`Until ${dateOfMonth}${dateSuffix} ${monthName}`);
        }

        // const allUk = state.searchForm.include_uk;
        // const searchRegion = allUk ? 'All UK' : 'NI Only';
        // selected.push(searchRegion);

        return selected.filter(Boolean);
    },
    selectedFiltersCaption: (state, getters) => getters.selectedFilters.map(filter => {
        if (typeof filter === 'string') {
            return filter;
        }
        const suffix = filter.suffix ? ' ' + filter.suffix : '';
        if (filter.from && filter.to) {
            return filter.from === filter.to
                ? `${filter.from}${suffix}`
                : `${filter.from} - ${filter.to}${suffix}`;
        }
        if (filter.from) {
            return `From ${filter.from}${suffix}`;
        }
        return `Up to ${filter.to}${suffix}`;
    }).join(' &middot; '),
    getNotificationFrequency: (state) => {
        const frequencies = state.frequencies || [];
        const frequencyId = state.notificationData.frequency || 0;
        return frequencies.find(item => item.value === frequencyId) || null;
    },
    getNotificationPeriod: (state) => {
        const periods = state.periods || [];
        const periodId = state.notificationData.period || 0;
        return periods.find(item => item.value === periodId) || null;
    },
    getNotificationData: (state) => {
        return { ...state.notificationData };
    },
    showIncludeUk: (state, getters) => getters.showIncludeUk
};
